/**
 * Field validators every staff module shares (tasks, contacts, documents, board meetings, board voting, expenses,
 * campaigns, cash gifts).  Moved here from tasks.js 2026-10-29; tasks.js re-exports them.
 *
 *   oneLine(v, label, max, required = true)   one line: whitespace runs collapse, control characters refused
 *   text(v, label, max, required = false)     several lines: CRLF → LF, trimmed, tab and newline allowed
 *   isId(v)                                   a lowercase UUID
 *   CONTROL                                   the control characters a text may not hold (tab and newline may)
 *   cap(s)                                    the label with a capital first letter, for a message
 *
 * `label` is the Norwegian phrase a message is made of: «Skriv en tittel.», «En tittel kan ha maks 120 tegn.». Mind the
 * defaults — `required` is true for oneLine and false for text; a caller that means otherwise says so.
 *
 * Pure: no I/O.
 */
'use strict';

const ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const isId = (v) => typeof v === 'string' && ID_RE.test(v);
const CONTROL = /[\u0000-\u0008\u000b-\u001f\u007f]/; // tab and newline are text; the rest is not

/** One line: whitespace runs collapse, control characters refused. → { ok, value } | { ok: false, message } */
function oneLine(v, label, max, required = true) {
  if (v === undefined || v === null || v === '') return required ? { ok: false, message: `Skriv ${label}.` } : { ok: true, value: null };
  if (typeof v !== 'string') return { ok: false, message: `${cap(label)} må være tekst.` };
  const s = v.replace(/\s+/g, ' ').trim();
  if (!s) return required ? { ok: false, message: `Skriv ${label}.` } : { ok: true, value: null };
  if (s.length > max) return { ok: false, message: `${cap(label)} kan ha maks ${max} tegn.` };
  if (CONTROL.test(s)) return { ok: false, message: `${cap(label)} kan ikke ha kontrolltegn.` };
  return { ok: true, value: s };
}
/** Several lines of plain text: trimmed, at most `max`, no control characters but tab and newline. */
function text(v, label, max, required = false) {
  if (v === undefined || v === null) return required ? { ok: false, message: `Skriv ${label}.` } : { ok: true, value: null };
  if (typeof v !== 'string') return { ok: false, message: `${cap(label)} må være tekst.` };
  const s = v.replace(/\r\n?/g, '\n').trim();
  if (!s) return required ? { ok: false, message: `Skriv ${label}.` } : { ok: true, value: null };
  if (s.length > max) return { ok: false, message: `${cap(label)} kan ha maks ${max} tegn.` };
  if (CONTROL.test(s)) return { ok: false, message: `${cap(label)} kan ikke ha kontrolltegn.` };
  return { ok: true, value: s };
}
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

module.exports = { ID_RE, isId, CONTROL, cap, oneLine, text };
